import React from 'react'
import { inject, observer } from 'mobx-react';
import Loader from '../../../generic/Loader';
import Table from '../../../generic/Table';
import Button from '../../../generic/Button';
import ClickableDiv from '../../../generic/ClickableDiv'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const NFETable = inject('nfeStore')(observer(props => {
  const { nfeStore } = props
  const { isFetching } = nfeStore.state
  const filterableHeader = <ClickableDiv onClick={() => nfeStore.toggleOrder()}>Última modificação <FontAwesomeIcon icon='sort' /></ClickableDiv>
  const tableHeaders = ['Xml', 'Nº NFE', 'Tipo', filterableHeader, '']
  const tableRows = nfeStore.orderedFiles.map(data => {
    const date = new Date(data.LastModified)
    const xmlNumber = data.Key.split('/')
    const xmlName = xmlNumber[xmlNumber.length - 1].split('_')[0]
    const buttonData = {
      text: 'Download',
      type: 'Button',
      onClick: () => nfeStore.downloadNfe(data.Key, xmlName),
      styleClass: 'is-success',
      isLoading: data.isDownloading
    }
    const viewButton = {
      text: 'Visualizar',
      type: 'Button',
      styleClass: 'is-info',
      onClick: () => {
        nfeStore.setSelectedXml(data.Key, date)
        nfeStore.getNfeBody()
      },
      isLoading: data.isViewing
    }
    const downloadButton = <div className='buttons'><Button fieldData={buttonData}/><Button fieldData={viewButton}/></div>
    return [xmlName, xmlName.substr(25, 9), data.type, date, downloadButton]
  })
  const formattedTableRows = tableRows.map(data => [data[0], data[1], data[2], data[3].toLocaleString('pt-br'), data[4]])
  return (
    <Loader isLoading={isFetching}>
      <Table headers={tableHeaders} rows={formattedTableRows}/>
    </Loader>
  )
}))

export default NFETable



// WEBPACK FOOTER //
// ./src/components/dashboard/products/4nfe/NFETable.js